export default "/assets/website/components/images/blabloom-logo.6107fd37.svg";